module.exports = __webpack_public_path__ + "img/31_31.af66b637.png";